import axios from "axios";

//const API_URL = process.env.API_URL || "http://localhost:3000/api/v0";
//const API_URL = process.env.API_URL || "http://10.0.2.2:3000/api/v0";
const API_URL = process.env.API_URL || "http://" + window.location.hostname + ":3000/api/v0";

export default axios.create({
	baseURL: API_URL,
	headers: {
		"Content-Type": "application/json",
		"X-API-Key": "XBJOguHValidatorFrontendqvaXnUuBpP5NsrIC"
	}
});
